module.exports = __webpack_public_path__ + "img/b-medal-gold.9f00de26.png";